<script>
import Alerts from "@/components/Alerts.vue";

export default {
    name: "Vendors",
    components: {Alerts},
    data() {
        return {
            vendor: {
                name: '',
                number: '',
                email: '',
                phone: '',
                address: '',
                comments: '',
            }
        }
    },
    mounted() {
    },
    methods: {
        editVendor() {
            this.$refs.addVendor.click()
        },
        createVendor() {
            this.clear()
            this.wait = true
            this.success = 'Please wait...'
            this.$http.post('/procurement/vendor', this.vendor).then(() => {
                this.success = 'Success'
                this.$refs.addVendor.click()
            }).catch(err => {
                this.showError(err)
            }).then(() => {
                this.wait = false
            })
        }
    }
}
</script>

<template>
    <div>
        <button type="button" class="btn btn-dark float-right" data-toggle="modal" data-target="#myModal"
                ref="addVendor">
            Add Vendor
        </button>

        <div class="clearfix"></div>
        <hr style="border:  1px dotted #ddd">

        <alerts :_success="success" :_error="error"></alerts>

        <section v-for="i in 4" :key="i" class="d-flex align-content-center align-items-center p-3 bg-white mb-3 rounded-sm">
            <div>
                <ion-icon name="camera-outline" class="icon" style="font-size: 100px; color: #ddd"></ion-icon>
            </div>
            <div class="px-4">
                <h5 class="font-weight-bold">The Gelian Ltd.</h5>
                <div>
                    These include delivery times, request for down payment, any special considerations etc

                    <div class="text-muted mb-1">
                        <ion-icon name="mail-unread-outline" class="icon"></ion-icon>
                        email@gelian.com &nbsp;
                        <ion-icon name="call-outline" class="icon"></ion-icon>
                        0712345678
                    </div>
                    <div class="d-flex mb-3">
                        <div class="flex-fill">
                            <ion-icon name="link-outline" class="icon"></ion-icon>
                            <a href=""> https://gelian.com</a> &nbsp;
                        </div>
                        <div>
                            <ion-icon name="bag-handle-outline" class="icon"></ion-icon>
                            23 orders in the past
                        </div>
                    </div>

                    <div>
                        <button class="btn btn-outline-dark btn-sm mr-1" @click.prevent="editVendor()">Edit Vendor
                        </button>
                        <button class="btn btn-outline-danger btn-sm mr-1">Remove</button>

                        <button class="btn btn-success btn-sm mr-1 float-right">Award Tender</button>
                    </div>
                </div>
            </div>
            <div class="p-4">
                <span class="text-muted">USD</span> <br>
                <h4 class="font">2,500</h4>
            </div>
        </section>

        <div class="modal" id="myModal">
            <div class="modal-dialog modal-static">
                <form class="modal-content" @submit.prevent="createVendor()">
                    <div class="modal-header">
                        <h5 class="font-weight-bold modal-title">Add Vendor</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body  bg-light">
                        <p class="text-muted">Enter vendor details</p>
                        <div class="form-group mb-3">
                            <label for="email">Vendor Name:</label>
                            <input type="text" class="form-control" v-model="vendor.name" :disabled="wait"
                                   placeholder="Vendor name"
                                   id="name">
                        </div>

                        <div class="form-group mb-3">
                            <label for="email">Vendor Number:</label>
                            <input type="text" class="form-control" v-model="vendor.number" :disabled="wait"
                                   placeholder="Vendor number"
                                   id="number">
                        </div>

                        <div class="form-group mb-3">
                            <label for="email">Phone:</label>
                            <input type="text" class="form-control" v-model="vendor.phone" :disabled="wait"
                                   placeholder="Contact phone"
                                   id="phone">
                        </div>

                        <div class="form-group mb-3">
                            <label for="email">E-Mail Address:</label>
                            <input type="text" class="form-control" v-model="vendor.email" :disabled="wait"
                                   placeholder="E-Mail address"
                                   id="email">
                        </div>

                        <div class="form-group mb-3">
                            <label for="address">Address Location:</label>
                            <input type="text" class="form-control" v-model="vendor.address" :disabled="wait"
                                   placeholder="Vendor address location" id="address">
                        </div>

                        <div class="form-group mb-3">
                            <label for="comments">Additional Comments:</label>
                            <textarea class="form-control" rows="4" v-model="vendor.comments" :disabled="wait"
                                      placeholder="Additional comments" id="comments"></textarea>
                        </div>

                        <div class="form-group">
                            <button type="submit" class="btn btn-success"  :disabled="wait">Submit</button>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<style scoped>
.icon {
    font-size: 18px;
    vertical-align: middle;
    color: gray
}
</style>